/** Постоянный ключ позволяет сохранить доставку при смене вида строк заказа. */
export const DELIVERY_ITEM_ID = 'clinic-delivery';
/** Доставка — самостоятельная позиция документа, а не прибавка к цене заказов. */
export function clinicDeliveryItems(clinic) {
    if (!clinic?.countDelivery)
        return [];
    return [{ id: DELIVERY_ITEM_ID, name: 'Доставка', qty: 1, unit: 'усл.', priceKop: clinic.deliveryKop ?? 0 }];
}
/** Последняя строка в счёте и акте. Сохранённая ручная правка доставки не теряется. */
export function withInvoiceDelivery(items, delivery) {
    const работы = items.filter((item) => item.id !== DELIVERY_ITEM_ID);
    const строка = delivery.find((item) => item.id === DELIVERY_ITEM_ID);
    return строка ? [...работы, строка] : работы;
}
/** В старых сохранённых счетах ключ автодоставки не хранился: узнаём её по точному названию. */
export function deliveryLast(items) {
    const isDelivery = (item) => item.id === DELIVERY_ITEM_ID || item.name.trim().toLocaleLowerCase('ru-RU') === 'доставка';
    return [...items.filter(item => !isDelivery(item)), ...items.filter(isDelivery)];
}
//# sourceMappingURL=invoice-delivery.js.map